import React, {FunctionComponent, useState} from 'react';

import {useQuery} from '@tanstack/react-query';
import SubjectAreasContent, {SubjectAreasFilterParams} from './SubjectAreasContent';
import {
    useSubjectAreaFilteredQueryConfig,
    useSubjectAreaFilterOptionsQueryConfig
} from '../../../query/SubjectArea/Query';

const SubjectAreas: FunctionComponent = () => {
    const [filters, setFilters] = useState<SubjectAreasFilterParams>({});

    const [subjectAreaConfig, setPage] = useSubjectAreaFilteredQueryConfig(filters);
    const [subjectAreaFilterOptionsConfig] = useSubjectAreaFilterOptionsQueryConfig();

    const subjectAreaQuery = useQuery(subjectAreaConfig);
    const filterOptionsQuery = useQuery(subjectAreaFilterOptionsConfig);

    if(!subjectAreaQuery.data || !filterOptionsQuery.data)
        return null;

    return (
        <SubjectAreasContent
            subjectAreas={subjectAreaQuery.data}
            filterOptions={filterOptionsQuery.data}
            filters={filters}
            setFilters={setFilters}
            onPageChange={setPage} />
    );
};

export default SubjectAreas;
